import { render, staticRenderFns } from "./ContactoModal.vue?vue&type=template&id=6478e0f8&scoped=true"
import script from "./ContactoModal.vue?vue&type=script&lang=js"
export * from "./ContactoModal.vue?vue&type=script&lang=js"
import style0 from "./ContactoModal.vue?vue&type=style&index=0&id=6478e0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478e0f8",
  null
  
)

export default component.exports